import { useDispatch, useSelector } from 'react-redux';

import SearchBox from '../../SearchBox';
import { RootState } from '../../../store';
import {
  setSearchInput,
  setSearchRequestStatus,
  RequestStatus,
} from '../../../store/textPanelContent';

import styles from './styles.module.css';

interface Props {
  toggleHeaderMode: () => void;
  darkMode: boolean;
}

const SearchModeHeader = ({ toggleHeaderMode, darkMode }: Props): JSX.Element => {
  const dispatch = useDispatch();
  const { searchInput } = useSelector((state: RootState) => state.textPanelContent);
  const { verse } = useSelector((state: RootState) => state.params);

  const setValue = (text: string) => {
    dispatch(setSearchInput(text));
  };

  const cancelButton = `${styles.cancelButton} ${darkMode && styles.cancelButtonDarkMode}`;

  const cancel = () => {
    dispatch(setSearchRequestStatus(RequestStatus.init));
    setTimeout(() => {
      dispatch(setSearchInput(''));
      toggleHeaderMode();
      // Wait for layouts to be loaded before scrolling
      const timer = setTimeout(() => {
        const element = document.getElementById(`row-${verse}`);
        if (element) {
          // const offset = element.offsetTop - 200;
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 1000);
      return () => clearTimeout(timer);
    }, 500);
  };

  return (
    <>
      <SearchBox setValue={setValue} value={searchInput} darkMode={darkMode} />
      <button className={cancelButton} type="button" onClick={cancel}>
        Cancel
      </button>
    </>
  );
};

export default SearchModeHeader;
